import { Badge, Button } from 'antd'
import cls from 'classnames'
import React from 'react'

import { GroupAvatar } from '@/components'
import { Pin } from '@/components/group-pin'
import { RequestedGroupFragment } from '@/generated/graphql'
import { routes } from '@/routes'

import { AsideMenuItem } from './aside-menu-item.component'
import s from './aside.module.less'

export const PriorityGroups: React.FC<{
  groups: (RequestedGroupFragment & { isPinned?: boolean | null; recentUnreadCount?: number | null })[]
}> = ({ groups }) => {
  const content = groups
    .slice()
    .reverse()
    .map((g: RequestedGroupFragment & { isPinned?: boolean | null; recentUnreadCount?: number | null }) => {
      const title = <span>{g.name}</span>
      return (
        <AsideMenuItem
          key={g.groupId}
          title={title}
          path={routes.groups.page(g.groupId)}
          icon={
            g.recentUnreadCount && g.isPinned ? (
              <Badge dot offset={[-6, 2]}>
                <GroupAvatar disableColor={true} groupCatId={g.category?.groupCategoryId} />
              </Badge>
            ) : (
              <GroupAvatar
                isOfficial={g.isOfficial}
                disableColor={!g.isOfficial}
                groupCatId={g.category?.groupCategoryId}
              />
            )
          }
          actions={<AsideGroupMoreButton group={g as any} />}
        />
      )
    })

  if (groups.length === 0) {
    return null
  }

  return <>{content}</>
}

export const AsideGroupMoreButton: React.FC<{ group: RequestedGroupFragment & { isPinned: boolean } }> = ({
  group,
}) => {
  if (group.isOfficial) {
    return null
  }
  const groupPin = (
    <Button size={'small'} shape={'circle'}>
      <Pin groupId={group.groupId} isPinned={group.isPinned} />
    </Button>
  )

  return <div className={cls(s.more, group.isPinned ? s.pinned : s.unpin)}>{groupPin}</div>
}
